export enum GameStage {
  Lobby = 'LOBBY',
  Question = 'QUESTION',
  Vote = 'VOTE',
  Results = 'RESULTS',
}
